import * as React from 'react';

export const qaFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_348)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#8B0D35'
            />
            <mask
                id='mask0_1_348'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_348)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.66667 0L10.6667 1.33333L6.66667 2.66667L10.6667 4L6.66667 5.33333L10.6667 6.66667L6.66667 8L10.6667 9.33333L6.66667 10.6667L10.6667 12L6.66667 13.3333L10.6667 14.6667L6.66667 16L10.6667 17.3333L6.66667 18.6667L10.6667 20H0V0H6.66667Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_348'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
